import { DependenciesInjection } from "app/di/DependencyInjection";
import { RoleManagementImpl } from "../data/RoleManagementImpl";
import { IRoleManagementRepository } from "../domain/repositories/IRoleManagementRepository";
import { RoleManagementUseCase } from "../domain/useCases/RoleManagementUseCase";
import { RoleManagementViewModel } from "../presentation/viewModel/RoleManagementViewModel";
import { RoleManagmentToken } from "./RoleManagementToken";

export class RoleManagementInjection {
  static initInjections() {
    DependenciesInjection.register<IRoleManagementRepository>(
      RoleManagmentToken.IRoleManagementRepository,
      RoleManagementImpl,
      "otherRepo",
    );
    DependenciesInjection.register<RoleManagementUseCase>(
      RoleManagmentToken.RoleManagementUseCase,
      RoleManagementUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<RoleManagementViewModel>(
      RoleManagmentToken.RoleManagementViewModel,
      RoleManagementViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IRoleManagementRepository>(
      RoleManagmentToken.IRoleManagementRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<RoleManagementUseCase>(
      RoleManagmentToken.RoleManagementUseCase,
    );
  }
}
